import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderAlertComponent } from './header-alert.component';
import { StoreModule } from '@ngrx/store';
import { alertReducers } from './redux/reducer';
import { HeaderAlertService } from './header-alert.service';

@NgModule({
  imports: [
    CommonModule,
    // BrowserAnimationsModule,
    StoreModule.forFeature('headerAlert', alertReducers)
  ],
  declarations: [HeaderAlertComponent],
  exports: [HeaderAlertComponent],
  providers: [HeaderAlertService]
})
export class HeaderAlertModule {}
